import React from 'react';
import { Box, Typography } from '@mui/material';
import PublisherCard from '../../../components/publisherCard';
import * as styles from './styles';

function DirectoryList({ publishers, onSync, onShare }) {
    function renderEmpty() {
        return (
            <Box sx={styles.empty}>
                <Typography>No publishers match those filters. Try clearing some.</Typography>
            </Box>
        );
    }

    function renderCards() {
        return publishers.map((publisher) => (
            <PublisherCard
                key={publisher.id}
                publisher={publisher}
                onSync={onSync}
                onShare={onShare}
            />
        ));
    }

    return (
        <Box sx={styles.grid}>
            {publishers.length === 0 ? renderEmpty() : renderCards()}
        </Box>
    );
}

export default DirectoryList;
